import { render, staticRenderFns } from "./KurccQuestionList.vue?vue&type=template&id=1230cc97&scoped=true&"
import script from "./KurccQuestionList.vue?vue&type=script&lang=js&"
export * from "./KurccQuestionList.vue?vue&type=script&lang=js&"
import style0 from "./KurccQuestionList.vue?vue&type=style&index=0&id=1230cc97&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1230cc97",
  null
  
)

export default component.exports